module.exports = __webpack_public_path__ + "img/危险源 类型.37156f13.png";